import styled from '@emotion/styled';
import { Variables } from '../../../base/variables';
import Icon from '@mdi/react';

export const CollapsibleHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    cursor: pointer;
    user-select: none;
`;

export const CollapsibleTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: ${Variables.Colors.n100};
`;

export const ExpandIcon = styled(Icon)<{ open: boolean }>`
    fill: ${Variables.Colors.n70};
    transition: transform 0.2s;
    transform: rotate(${props => (props.open ? '90deg' : '0deg')});
`;

export const CollapsibleContent = styled.div<{ open: boolean }>`
    display: ${props => (props.open ? 'block' : 'none')};
    padding-top: 8px;
`;

export const CurrencyInputWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    
    > div {
        width: 100%;
    }
    
    input {
        width: 100%;
    }
`;

export const CurrencyPrefix = styled.span`
    position: absolute;
    left: 12px;
    font-size: 14px;
    color: ${Variables.Colors.n70};
    pointer-events: none;
    z-index: 1;
`;

export const DropzoneSubtext = styled.div`
    font-size: 12px;
    color: ${Variables.Colors.n50};
`;

